'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dApp$002dRouter$0024$002dPrint$002dRecipes$002dApp$002dPage from "./mealorama.-App-Router$-Print-Recipes-App-Page.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$PrintRecipesAppPage$() {
}
export { $c_Lmealorama_AppRouter$PrintRecipesAppPage$ as $c_Lmealorama_AppRouter$PrintRecipesAppPage$ };
$p = $c_Lmealorama_AppRouter$PrintRecipesAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$PrintRecipesAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$PrintRecipesAppPage$() {
}
export { $h_Lmealorama_AppRouter$PrintRecipesAppPage$ as $h_Lmealorama_AppRouter$PrintRecipesAppPage$ };
$h_Lmealorama_AppRouter$PrintRecipesAppPage$.prototype = $p;
$p.m = (function() {
  return "PrintRecipesAppPage";
});
$p.aS6 = (function(x$0) {
  return new $j_mealorama$002e$002dApp$002dRouter$0024$002dPrint$002dRecipes$002dApp$002dPage.$c_Lmealorama_AppRouter$PrintRecipesAppPage(x$0.g(0));
});
var $d_Lmealorama_AppRouter$PrintRecipesAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$PrintRecipesAppPage$, "mealorama.AppRouter$PrintRecipesAppPage$", ({
  Fv: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_AppRouter$PrintRecipesAppPage$ as $d_Lmealorama_AppRouter$PrintRecipesAppPage$ };
var $n_Lmealorama_AppRouter$PrintRecipesAppPage$;
function $m_Lmealorama_AppRouter$PrintRecipesAppPage$() {
  if ((!$n_Lmealorama_AppRouter$PrintRecipesAppPage$)) {
    $n_Lmealorama_AppRouter$PrintRecipesAppPage$ = new $c_Lmealorama_AppRouter$PrintRecipesAppPage$();
  }
  return $n_Lmealorama_AppRouter$PrintRecipesAppPage$;
}
export { $m_Lmealorama_AppRouter$PrintRecipesAppPage$ as $m_Lmealorama_AppRouter$PrintRecipesAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Print-Recipes-App-Page$.js.map
